import {Entity} from "@backstage/catalog-model";
import {JsonValue} from "@backstage/types";

// Configuration for schema-like entities (Schema and Api kinds)
export interface SchemaEntityConfig {
  kind: 'Schema' | 'Api';
  displayName: string;        // Schema display name to show on tab
  displayNamePlural: string;  // Schema display name plural
  sourcePath: string;         // Schema source path in the repo
  goDocsPath: string;         // Schema Go docs path
}

export const SCHEMA_CONFIG: SchemaEntityConfig = {
  kind: 'Schema',
  displayName: 'schema',
  displayNamePlural: 'Schemas',
  sourcePath: 'weave/schemas',
  goDocsPath: 'schemas',
};

export const API_CONFIG: SchemaEntityConfig = {
  kind: 'Api',
  displayName: 'API',
  displayNamePlural: 'APIs',
  sourcePath: 'apis',
  goDocsPath: 'apis',
};

// Shared spec interface for both Schema and Api entities
export interface SchemaEntitySpec {
  lifecycle: string;
  owner: string;
  definition: string;
  system?: string;
  repos?: string[];
  schema: {
    path: string;
  };
  openApiDocs: string;
  [key: string]: JsonValue | undefined;
}

// Shared type for components that work with either Schema or Api entities
export interface SchemaEntity extends Entity {
  apiVersion: 'switchboard.weavelab.xyz/v1alpha1';
  kind: 'Schema' | 'Api';
  spec: SchemaEntitySpec;
}
